<template>
  <div>
    <v-container grid-list-xl fluid class="pl-6 pr-5">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex xs12 mb-3 class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            SPENDING REPORT
          </h2>
          <v-breadcrumbs
            class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
      </v-layout>
      <v-card class="mx-2">
        <v-card-title class="primary pa-2 white--text">
          <span id="titleBrand" class="title pl-2" v-if="id">
            MASS REVISION
          </span>
          <span id="titleBrand" class="title pl-2" v-else>
            ADD NEW {{ isAdhoc ? 'AD HOC IO' : 'IO' }}
          </span>
          <v-spacer></v-spacer>
          <h5 class="subtitle-2	pl-2">Step {{ e1 }} from 3</h5>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            <v-col sm="12" class="pt-0">
              <v-stepper v-model="e1" :alt-labels="true">
                <template>
                  <v-flex xs12 class="text-right">
                    <v-btn
                      text
                      class="secondblue--text f-14 text-capitalize mr-2 mb-2"
                      @click="dialog = true"
                    >
                      Taxonomy Guideline
                      <img
                        src="@/assets/images/icon/book-open.png"
                        width="17px"
                        class="ml-2"
                      />
                    </v-btn>
                  </v-flex>
                  <v-row justify="center">
                    <v-dialog v-model="dialog" width="85%">
                      <v-card>
                        <v-card-title class="primary pr-2">
                          <span class="white--text text-uppercase">
                            Taxonomy Guideline
                          </span>
                          <v-spacer></v-spacer>
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <VuePerfectScrollbar
                          class="drawer-menu--scroll-dialog"
                          :settings="scrollSettings"
                        >
                          <v-card-text>
                            <v-row justify="center" align="center" class="px-2">
                              <img
                                class="mt-0"
                                style="max-width: 100%"
                                src="@/assets/images/taxo.jpg"
                              />
                            </v-row>
                          </v-card-text>
                        </VuePerfectScrollbar>
                      </v-card>
                    </v-dialog>
                  </v-row>
                  <v-stepper-header class="mb-5">
                    <template>
                      <v-stepper-step :complete="e1 > 1" step="1">
                        <span v-if="id">
                          Revise IO
                        </span>
                        <span v-else>
                          Add New {{ isAdhoc ? 'Ad hoc' : 'IO' }}
                        </span>
                      </v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step :complete="e1 > 2" step="2">
                        Attach Supporting Document
                      </v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step :complete="e1 > 3" step="3">
                        Review
                      </v-stepper-step>
                    </template>
                  </v-stepper-header>
                  <v-row class="px-3">
                    <v-col sm="12" v-if="items.length > 0">
                      <template>
                        <v-simple-table
                          fixed-header
                          class="table-taxonomy nav-table"
                        >
                          <template v-slot:default>
                            <VuePerfectScrollbar
                              class="drawer-menu--scroll"
                              :settings="scrollSettings"
                            >
                              <thead>
                                <tr class="primary">
                                  <template v-if="isStatus === 'revise'">
                                    <th
                                      v-for="itemHeader in bcHeader"
                                      :key="itemHeader.text"
                                      style="white-space:nowrap;"
                                      class="f-14 primary white--text"
                                    >
                                      {{ itemHeader.text }}
                                    </th>
                                  </template>
                                  <th
                                    v-for="header in headers"
                                    :key="header.text"
                                    style="white-space:nowrap;"
                                    class="f-14 primary white--text"
                                  >
                                    {{ header.text }}
                                  </th>
                                  <th
                                    v-for="item in months"
                                    :key="item"
                                    class="f-14 primary white--text"
                                  >
                                    {{ item }}
                                  </th>
                                  <template v-if="isStatus === 'revise'">
                                    <th
                                      v-for="amountheader in amountHeaders"
                                      :key="amountheader.text"
                                      style="white-space:nowrap;"
                                      class="f-14 primary white--text"
                                    >
                                      {{ amountheader.text }}
                                    </th>
                                  </template>
                                  <!-- <th
                                    colspan="13"
                                    class="f-14 primary white--text text-center"
                                  >
                                    Amount
                                  </th> -->
                                  <th
                                    class="f-14 primary white--text"
                                    v-if="e1 >= 2"
                                  >
                                    Supporting Doc
                                  </th>
                                </tr>
                                <!-- <tr>
                                  
                                </tr> -->
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in items"
                                  :key="item.id"
                                  @click="showDetail(item)"
                                  :style="e1 === 2 ? 'cursor: pointer;' : ''"
                                >
                                  <template v-if="isStatus === 'revise'">
                                    <td>{{ item.budget_code }}</td>
                                  </template>
                                  <td>
                                    {{ item.io_number ? item.io_number : '-' }}
                                  </td>
                                  <td>{{ item.code ? item.code : '-' }}</td>
                                  <td>{{ item.entity_name }}</td>
                                  <td>{{ item.brand_name }}</td>
                                  <!-- <td>{{ item.department_name }}</td> -->
                                  <!-- <td v-if="isLoggedInAsHN">
                                    {{ item.hn_category }}
                                  </td> -->
                                  <td>{{ item.product }}</td>
                                  <td v-if="isLoggedInAsSales">
                                    <v-tooltip
                                      bottom
                                      v-if="item.channel.length > 3"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <span v-on="on">
                                          {{
                                            item.channel
                                              .slice(0, 3)
                                              .map(val => val.name)
                                              .join(', ')
                                          }}
                                          ...
                                        </span>
                                      </template>
                                      <span>
                                        {{
                                          item.channel
                                            .map(val => val.name)
                                            .join(', ')
                                        }}
                                      </span>
                                    </v-tooltip>
                                    <span v-else>
                                      {{
                                        item.channel
                                          .map(val => val.name)
                                          .join(', ')
                                      }}
                                    </span>
                                  </td>
                                  <td v-if="isLoggedInAsSales">
                                    <v-tooltip
                                      bottom
                                      v-if="item.account.length > 3"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <span v-on="on">
                                          {{
                                            item.account
                                              .slice(0, 3)
                                              .map(val => val.name)
                                              .join(', ')
                                          }}
                                          ...
                                        </span>
                                      </template>
                                      <span>
                                        {{
                                          item.account
                                            .map(val => val.name)
                                            .join(', ')
                                        }}
                                      </span>
                                    </v-tooltip>
                                    <span v-else>
                                      {{
                                        item.account
                                          .map(val => val.name)
                                          .join(', ')
                                      }}
                                    </span>
                                  </td>
                                  <td v-if="!id">{{ item.stage }}</td>
                                  <!-- <td>{{ item.budget_owner }}</td>
                                  <td>{{ item.pic }}</td> -->
                                  <td>{{ item.cc_desc }}</td>
                                  <td>{{ item.cc }}</td>
                                  <td>{{ item.ce_desc }}</td>
                                  <td>{{ item.ce }}</td>
                                  <td class="text-capitalize">
                                    {{ item.method }}
                                  </td>
                                  <td>{{ item.campaign }}</td>
                                  <td>{{ formatDate(item.start) }}</td>
                                  <td>{{ formatDate(item.end) }}</td>
                                  <td v-if="isLoggedInAsSales">
                                    {{
                                      item.investment_type
                                        ? item.investment_type.name
                                        : '-'
                                    }}
                                  </td>
                                  <td>{{ item.activity_desc }}</td>
                                  <td
                                    v-for="amount in item.amount"
                                    :key="amount.month"
                                    class="text-right"
                                  >
                                    {{ idr(amount.value) }}
                                  </td>
                                  <template v-if="isStatus === 'revise'">
                                    <td class="text-right">
                                      {{ idr(item.q1) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.q2) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.q3) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.q4) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.po) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.non_po) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.remaining_io) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.gr) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.actual_non_po) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.remaining_po) }}
                                    </td>
                                    <td class="text-right">
                                      {{ idr(item.remaining_non_po) }}
                                    </td>
                                    <td class="text-uppercase">
                                      {{ item.status ? item.status : '-' }}
                                    </td>
                                  </template>
                                  <td v-if="e1 >= 2 && item.isUploaded">
                                    Uploaded
                                    <v-icon color="success">
                                      check_circle
                                    </v-icon>
                                  </td>
                                  <td v-else-if="e1 >= 2">
                                    <span
                                      class="primary--text"
                                      style="text-decoration:underline"
                                    >
                                      Upload Now
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </VuePerfectScrollbar>
                          </template>
                        </v-simple-table>
                      </template>
                    </v-col>
                    <v-col sm="12" v-else class="greydark mb-5">
                      <p class="text-center pt-3">No data displayed</p>
                    </v-col>
                  </v-row>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-row>
                        <v-col sm="12" class="text-center btn-tab-upload">
                          <span class="btn-tab-outer">
                            <v-btn
                              :text="uploadIo === false"
                              depressed
                              color="primary"
                              class="text-capitalize btn-upload-io f-14"
                              @click="changeManual"
                            >
                              {{ isAdhoc ? 'Upload Ad hoc IO' : 'Upload IO' }}
                            </v-btn>
                            <v-btn
                              v-if="!id"
                              :text="uploadIo"
                              depressed
                              color="primary"
                              class="text-capitalize btn-add-manual f-14"
                              @click="changeUpload"
                            >
                              Add Manually
                            </v-btn>
                          </span>
                        </v-col>
                      </v-row>
                      <v-layout row wrap v-if="uploadIo === true">
                        <v-flex xs12 id="uploadIO">
                          <p v-if="id" class="f-18 bluedark--text">
                            Upload IO (Revision File)
                          </p>
                          <p v-else class="f-18 bluedark--text">Upload IO</p>
                          <vue-dropzone
                            :use-font-awesome="true"
                            ref="myVueDropzone"
                            id="dropzone"
                            :options="dropzoneOptionsIO"
                            @vdropzone-complete="afterComplete"
                            @vdropzone-reset="afterRemoved"
                          ></vue-dropzone>
                          <v-btn
                            id="btn-convert"
                            class="secondblue mt-3 mb-2 white--text"
                            block
                            :disabled="isDisabled"
                            @click="parseFile"
                          >
                            Convert File to Table
                          </v-btn>
                          <v-btn
                            v-if="!id"
                            id="btn-convert"
                            class="thirdblue mt-3 white--text"
                            block
                            @click="getTemplate"
                          >
                            Download Template
                            {{ isAdhoc ? 'Ad hoc IO' : 'Spending' }}
                          </v-btn>
                          <span
                            v-if="id"
                            class="fs-10 red--text font-weight-bold"
                          >
                            *Notes :<br />
                            <ul class="pl-5">
                              <li>
                                {{
                                  flow
                                    ? 'Revisions can be applied only for current IO/NC you want to revise.'
                                    : 'Revisions can be applied only for current IO.'
                                }}
                              </li>
                              <li>
                                Unable to add or delete IO through this
                                procedure.
                              </li>
                              <li>
                                If you want to add IO, please click "ADD IO"
                                button in Spending Report page.
                              </li>
                            </ul>
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-layout v-else row wrap>
                        <v-flex xs2 class="secondblue--text body-1 text-left">
                          <p>Information</p>
                        </v-flex>
                        <v-flex xs10 class="pr-3 pt-3 mt-3"
                          ><hr class="line"
                        /></v-flex>
                        <v-flex xs12 class="py-0 mb-5">
                          <table width="100%">
                            <tr>
                              <td
                                width="17.1%"
                                class="font-weight-bold darkblue--text"
                              >
                                Created Date
                              </td>
                              <td width="17.1%">{{ today }}</td>
                              <td
                                width="17.1%"
                                class="font-weight-bold darkblue--text"
                              >
                                House
                              </td>
                              <td width="17.1%">{{ item.house_name || '' }}</td>
                              <td
                                width="17.1%"
                                class="font-weight-bold darkblue--text"
                              >
                                Entity
                              </td>
                              <td width="17.1%">
                                {{ item.entity_name || '' }}
                              </td>
                            </tr>
                            <tr>
                              <td
                                width="17.1%"
                                class="font-weight-bold darkblue--text"
                              >
                                Budget Owner
                              </td>
                              <td width="17.1%">
                                {{ item.budget_owner || '-' }}
                              </td>
                              <td
                                width="17.1%"
                                class="font-weight-bold darkblue--text"
                              >
                                Brand
                              </td>
                              <td v-if="!isBrandNull" width="17.1%">
                                {{ item.brand_name || '-' }}
                              </td>
                              <td v-else class="py-2">
                                <v-autocomplete
                                  id="brandId"
                                  placeholder="Select Brand"
                                  v-model="brand"
                                  required
                                  dense
                                  outlined
                                  :items="brands"
                                  item-text="name"
                                  return-object
                                  autocomplete="off"
                                  hide-details="auto"
                                ></v-autocomplete>
                              </td>
                            </tr>
                          </table>
                        </v-flex>
                        <v-col sm="12">
                          <ValidationObserver ref="obs">
                            <v-row>
                              <v-col sm="3" class="pr-0 py-0">
                                <ValidationProvider
                                  name="year"
                                  rules="required"
                                  v-slot="{ errors, valid }"
                                >
                                  <label class="darkblue--text">Year</label>
                                  <date-picker
                                    v-model="item.year"
                                    type="year"
                                    placeholder="Year"
                                    format="YYYY"
                                    class="yearIO mb-4"
                                    required
                                    :success="valid"
                                    :error-messages="errors"
                                  >
                                  </date-picker>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="product"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text"
                                    >Product Hierarchy</label
                                  >
                                  <v-autocomplete
                                    v-model="item.product"
                                    placeholder="Select Product"
                                    :items="product_hierarchies"
                                    item-text="material_desc"
                                    dense
                                    return-object
                                    required
                                    :error-messages="errors"
                                    single-line
                                    outlined
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="stage"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">Stage</label>
                                  <v-text-field
                                    dense
                                    disabled
                                    v-model="item.stage"
                                    placeholder="Select"
                                    single-line
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <!-- <v-col class="py-0" sm="3">
                                <ValidationProvider
                                  name="pic"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">PIC</label>
                                  <v-text-field
                                    v-model="item.pic"
                                    dense
                                    label="PIC"
                                    single-line
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col> -->
                              <v-col class="py-0" sm="3">
                                <ValidationProvider
                                  name="Cost Center"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Cost Center
                                  </label>
                                  <v-autocomplete
                                    v-model="item.taxonomy"
                                    :items="taxonomies"
                                    dense
                                    required
                                    return-object
                                    item-text="costCenter.desc"
                                    placeholder="Select"
                                    :error-messages="errors"
                                    single-line
                                    outlined
                                  >
                                    <template
                                      slot="selection"
                                      slot-scope="data"
                                    >
                                      {{
                                        data.item.costCenter
                                          ? data.item.costCenter.code
                                          : 'null'
                                      }}
                                      -
                                      {{
                                        data.item.costCenter
                                          ? data.item.costCenter.desc
                                          : 'null'
                                      }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                      {{
                                        data.item.costCenter
                                          ? data.item.costCenter.code
                                          : 'null'
                                      }}
                                      -
                                      {{
                                        data.item.costCenter
                                          ? data.item.costCenter.desc
                                          : 'null'
                                      }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="costElement"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Cost Element
                                  </label>
                                  <v-text-field
                                    v-model="item.costElement"
                                    dense
                                    disabled
                                    placeholder="Cost Element"
                                    single-line
                                    outlined
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="material"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text"
                                    >Material Group</label
                                  >
                                  <v-text-field
                                    v-model="item.material"
                                    disabled
                                    dense
                                    label="Material"
                                    :error-messages="errors"
                                    single-line
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="nature"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Nature Activity
                                  </label>
                                  <v-text-field
                                    v-model="item.nature_activity"
                                    disabled
                                    dense
                                    label="Nature Activity"
                                    single-line
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="py-0" sm="3">
                                <ValidationProvider
                                  name="category"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Category
                                  </label>
                                  <v-text-field
                                    v-model="item.taxonomy_category"
                                    disabled
                                    label="Category"
                                    dense
                                    single-line
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="Working/Non Working"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Working/Non Working
                                  </label>
                                  <v-autocomplete
                                    v-model="item.pillars"
                                    :items="pillars"
                                    item-text="name"
                                    item-value="value"
                                    label="Select Working/Non Working"
                                    :error-messages="errors"
                                    dense
                                    single-line
                                    outlined
                                    disabled
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="method"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Method
                                  </label>
                                  <v-autocomplete
                                    v-model="item.method"
                                    :items="methods"
                                    item-text="name"
                                    item-value="value"
                                    :error-messages="errors"
                                    dense
                                    label="Select Method"
                                    single-line
                                    outlined
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="campaign"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">Campaign</label>
                                  <v-text-field
                                    v-model="item.campaign"
                                    placeholder="Campaign"
                                    single-line
                                    dense
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="py-0" sm="3">
                                <ValidationProvider
                                  name="bpc"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">BPC Line</label>
                                  <v-text-field
                                    v-model="item.bpc_line"
                                    disabled
                                    label="Select"
                                    dense
                                    single-line
                                    :error-messages="errors"
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="start"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Start Date
                                  </label>
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="item.start"
                                        placeholder="Start"
                                        prepend-inner-icon="event"
                                        dense
                                        readonly
                                        single-line
                                        :error-messages="errors"
                                        outlined
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.start"
                                      no-title
                                      scrollable
                                      :min="minDate"
                                      :max="maxDate"
                                    >
                                      <!-- <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(item.start)"
                                      >
                                        OK
                                      </v-btn> -->
                                    </v-date-picker>
                                  </v-menu>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="pr-0 py-0" sm="3">
                                <ValidationProvider
                                  name="end"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">End Date</label>
                                  <v-menu
                                    ref="menu2"
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    required
                                    :error-messages="errors"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="item.end"
                                        placeholder="End"
                                        prepend-inner-icon="event"
                                        readonly
                                        dense
                                        required
                                        single-line
                                        outlined
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.end"
                                      no-title
                                      scrollable
                                      :min="minDate"
                                      :max="maxDate"
                                    >
                                      <!-- <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu2 = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu2.save(item.end)"
                                      >
                                        OK
                                      </v-btn> -->
                                    </v-date-picker>
                                  </v-menu>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                class="py-0 pr-0"
                                sm="3"
                                v-if="isLoggedInAsSales"
                              >
                                <ValidationProvider
                                  name="Investment Type"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text"
                                    >Investment Type</label
                                  >
                                  <v-autocomplete
                                    v-model="item.investment_type"
                                    :items="investment_types"
                                    item-text="name"
                                    item-value="value"
                                    label="Investment Type"
                                    :error-messages="errors"
                                    return-object
                                    dense
                                    single-line
                                    outlined
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col class="py-0" sm="3">
                                <ValidationProvider
                                  name="activity"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">
                                    Activity Description
                                  </label>
                                  <v-text-field
                                    v-model="item.activity_desc"
                                    placeholder="Type here"
                                    :error-messages="errors"
                                    dense
                                    single-line
                                    outlined
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                class="pr-0 py-0"
                                sm="4"
                                v-if="isLoggedInAsSales"
                              >
                                <form-channel
                                  @saveChannel="saveChannel"
                                  :account.sync="item.account"
                                />
                              </v-col>
                            </v-row>
                            <span
                              v-if="validationMessage != ''"
                              class="red--text caption"
                              >{{ validationMessage }}</span
                            >
                            <v-row>
                              <v-flex
                                xs2
                                class="secondblue--text body-1 text-left"
                              >
                                <p>Amount</p>
                              </v-flex>
                              <v-flex xs10 class="pr-3 pt-3 mt-3"
                                ><hr class="line"
                              /></v-flex>
                              <v-flex
                                xs3
                                class="py-0"
                                v-for="(val, index) in item.amount"
                                :key="index"
                              >
                                <ValidationProvider
                                  :name="val.month"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <label class="darkblue--text">{{
                                    val.month
                                  }}</label>
                                  <v-currency-field
                                    :id="val.month"
                                    :placeholder="val.month"
                                    single-line
                                    v-model="val.value"
                                    :item="item.amount"
                                    outlined
                                    :disabled="
                                      val.month === 'Total' ||
                                        monthCheck(val.month)
                                    "
                                    :error-messages="errors"
                                  />
                                </ValidationProvider>
                              </v-flex>
                            </v-row>
                          </ValidationObserver>
                        </v-col>
                        <v-col sm="12">
                          <v-btn
                            block
                            depressed
                            color="info"
                            class="text-capitalize btn-add-manual f-14"
                            @click="addData()"
                            :disabled="isDisabledAdd"
                          >
                            Add Data
                          </v-btn>
                        </v-col>
                      </v-layout>
                      <v-divider class="my-4"></v-divider>
                      <v-col sm="12" class="text-right pa-0">
                        <v-btn
                          depressed
                          color="#8F8F8F"
                          class="text-capitalize white--text mr-3"
                          :to="{ name: 'spending' }"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          depressed
                          color="primary"
                          @click="nextStep(e1)"
                          class="text-capitalize"
                          :disabled="items === null || items.length === 0"
                        >
                          Next
                        </v-btn>
                      </v-col>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="px-0">
                      <supporting-docs :show="dialog1"> </supporting-docs>
                      <template v-if="detailIO" id="detailIO">
                        <div
                          v-for="(form, index) in items"
                          :key="form.id"
                          v-show="form.code === code"
                        >
                          <v-layout row wrap class="py-3">
                            <span class="ml-3 pt-2 f-18 darkblue--text"
                              >Upload IO</span
                            >
                            <v-spacer></v-spacer>
                            <v-flex
                              xs3
                              class="text-right"
                              v-if="!isLoggedInAsSales"
                            >
                              <v-btn
                                text
                                class="secondblue--text text-capitalize f-14"
                                @click="dialog1 = !dialog1"
                              >
                                Required sup.docs
                                <v-icon small color="secondblue" class="ml-2">
                                  mdi-square-edit-outline
                                </v-icon>
                              </v-btn>
                            </v-flex>
                            <!-- modal supporting docs -->
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs3>
                              <label class="darkblue--text">Code</label>
                              <v-text-field
                                disabled
                                placeholder="Code"
                                single-line
                                outlined
                                v-model="form.code"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                              <label class="darkblue--text">
                                GL Protein desc
                              </label>
                              <v-text-field
                                disabled
                                placeholder="GL Protein desc"
                                single-line
                                outlined
                                v-model="form.ce_desc"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                              <label class="darkblue--text">GL Protein</label>
                              <v-text-field
                                disabled
                                placeholder="GL Protein"
                                single-line
                                outlined
                                v-model="form.ce"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <span
                            >Only file types document .doc, .docx, .xls, .xlsx,
                            .ppt, .pptx, .pdf are allowed.</span
                          >
                          <v-layout row wrap class="upload-docs">
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 1
                                <!-- A & P Investment Breakdown -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'AP'))
                                "
                                @vdropzone-complete="
                                  onComplete($event, index, (name = 'AP'))
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 2
                                <!-- Cost estimation & detail production plan -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Cost Estimate'))
                                "
                                @vdropzone-complete="
                                  onComplete(
                                    $event,
                                    index,
                                    (name = 'Cost Estimate')
                                  )
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 3
                                <!-- Proposal   -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Proposal'))
                                "
                                @vdropzone-complete="
                                  onComplete($event, index, (name = 'Proposal'))
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 4
                                <!-- Storyboard -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Storyboard'))
                                "
                                @vdropzone-complete="
                                  onComplete(
                                    $event,
                                    index,
                                    (name = 'Storyboard')
                                  )
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 5
                                <!-- Storyboard -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Media Schedule'))
                                "
                                @vdropzone-complete="
                                  onComplete(
                                    $event,
                                    index,
                                    (name = 'Media Schedule')
                                  )
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 6
                                <!-- Storyboard -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Agreement'))
                                "
                                @vdropzone-complete="
                                  onComplete(
                                    $event,
                                    index,
                                    (name = 'Agreement')
                                  )
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 7
                                <!-- Storyboard -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'ROI'))
                                "
                                @vdropzone-complete="
                                  onComplete($event, index, (name = 'ROI'))
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex md3>
                              <label class="darkblue--text">
                                Document 8
                                <!-- Storyboard -->
                              </label>
                              <vue-dropzone
                                :use-font-awesome="true"
                                :ref="'myVueDropzone' + index"
                                :id="'dropzone' + index"
                                :options="dropzoneOptions"
                                @vdropzone-reset="
                                  fileRemoved(index, (name = 'Distribution'))
                                "
                                @vdropzone-complete="
                                  onComplete(
                                    $event,
                                    index,
                                    (name = 'Distribution')
                                  )
                                "
                              ></vue-dropzone>
                            </v-flex>
                            <v-flex xs12>
                              <v-btn
                                class="secondblue text-capitalize f-13 white--text"
                                block
                                @click="uploadFile(index)"
                                :disabled="form.btnDisabled"
                              >
                                Upload
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </template>
                      <v-divider class="my-4"></v-divider>
                      <v-col sm="12" class="text-right pa-0">
                        <v-btn
                          depressed
                          outlined
                          class="text-capitalize mr-3"
                          @click="prevStep(e1)"
                        >
                          Previous
                        </v-btn>
                        <v-btn
                          depressed
                          color="primary"
                          :disabled="btnNextDisabled"
                          @click="nextStep(e1)"
                          class="text-capitalize"
                        >
                          Next
                        </v-btn>
                      </v-col>
                    </v-stepper-content>
                    <v-stepper-content step="3" class="px-0">
                      <v-divider class="my-4"></v-divider>
                      <v-col sm="12" class="text-right pa-0">
                        <v-btn
                          depressed
                          outlined
                          class="text-capitalize mr-3"
                          @click="prevStep(e1)"
                        >
                          Previous
                        </v-btn>
                        <v-btn
                          depressed
                          v-if="id"
                          color="primary"
                          class="text-capitalize"
                          @click="confirmStatusRevise()"
                        >
                          Finish
                        </v-btn>
                        <v-btn
                          depressed
                          v-else
                          color="primary"
                          class="text-capitalize"
                          @click="confirmStatus()"
                        >
                          Finish
                        </v-btn>
                      </v-col>
                    </v-stepper-content>
                  </v-stepper-items>
                </template>
              </v-stepper>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import SuportingDocs from '@/components/supporting_docs';
import Swal from 'sweetalert2';
import vue2Dropzone from 'vue2-dropzone';
import moment from 'moment';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import ACLMixin from '@/mixins/ACLMixin';
import formChannel from '@/components/formChannel';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'supporting-docs': SuportingDocs,
    vueDropzone: vue2Dropzone,
    VuePerfectScrollbar,
    'form-channel': formChannel
  },
  mixins: [ACLMixin, LoginAsMixin],
  props: ['id', 'flow'],
  data() {
    return {
      activeMonth: [],
      validationMessage: '',
      scrollSettings: {
        maxScrollbarLength: 260
      },
      isStatus: '',
      menu: false,
      menu2: false,
      statusIO: '',
      isDisabled: true,
      isDisabledAdd: false,
      btnNextDisabled: true,
      loading: true,
      progressDialogLoading: true,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        timeout: 100000,
        acceptedFiles:
          '.xlsx, .xls, .XLS, .XLSX, .doc, .DOC, .docx, .DOCX, .pdf, .PDF, .ppt, .PPT, .pptx, .PPTX',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      dropzoneOptionsIO: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        timeout: 100000,
        acceptedFiles: '.xlsx, .xls',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      search: '',
      addMoreIO: false,
      options: {},
      totalItems: 0,
      dialog: false,
      dialog1: false,
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'SPENDING REPORT/ADD NEW IO',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      bcHeader: [{ text: 'Budget Code' }],
      headers: [
        { text: 'IO Number' },
        { text: 'Code' },
        { text: 'Entity' },
        { text: 'Brand' },
        // { text: 'Department' },
        { text: 'Product Hierarchy' },
        { text: 'Stage' },
        // { text: 'Budget Owner' },
        // { text: 'PIC' },
        { text: 'Cost Center Desc' },
        { text: 'Cost Center' },
        { text: 'Cost Element Desc' },
        { text: 'Cost Element' },
        { text: 'Method' },
        { text: 'Campaign' },
        { text: 'Start' },
        { text: 'End' },
        { text: 'Activity Description' }
      ],
      items: [],
      e1: 1,
      steps: 3,
      editable: true,
      brands: [],
      brand: {},
      uploadIo: true,
      detailIO: false,
      code: 0,
      xlxFile: {},
      nameFile: '',
      ce_desc: '',
      ce_code: '',
      support_docs: [],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Total'
      ],
      guidelines: [
        {
          name: 'Advertising',
          code_cost_element: '345115',
          desc: 'Costs related to media'
        },
        {
          name: 'Advertising',
          code_cost_element: '811115',
          desc: 'Costs related to media'
        },
        {
          name: 'Media',
          code_cost_element: '6115',
          desc: 'Costs related to media'
        },
        {
          name: 'Media',
          code_cost_element: '4115',
          desc: 'Costs related to media'
        },
        {
          name: 'Media',
          code_cost_element: '341115',
          desc: ' related to media'
        },
        {
          name: 'Shopper',
          code_cost_element: '311115',
          desc: 'Costs  to media'
        }
      ],
      baseUrl: process.env.VUE_APP_BASE_URL,
      isAdhoc: false,
      today: new Date(),
      product_hierarchies: [],
      pillars: [
        {
          name: 'Working',
          value: 'working'
        },
        {
          name: 'Non Working',
          value: 'non working'
        }
      ],
      methods: [
        {
          name: 'Traditional',
          value: 'traditional'
        },
        {
          name: 'Digital',
          value: 'digital'
        }
      ],
      channels: [],
      item: {
        entity_name: '',
        entity_id: 0,
        brand_name: '',
        brand_id: 0,
        house_name: '',
        house_id: 0,
        product: null,
        stage: '',
        cc_desc: '',
        cc: '',
        costElement: '',
        material: '',
        nature_activity: '',
        taxonomy_category: '',
        budget_owner: '',
        budget_owner_id: 0,
        pic: '',
        taxonomy: null,
        taxonomy_code: '',
        budget_code: '',
        pillars: '',
        method: '',
        channel: [],
        account: [],
        investment_type: '',
        campaign: '',
        bpc_line: '',
        start: '',
        end: '',
        activity_desc: '',
        amount: [
          {
            month: 'January',
            value: 0
          },
          {
            month: 'February',
            value: 0
          },
          {
            month: 'March',
            value: 0
          },
          {
            month: 'April',
            value: 0
          },
          {
            month: 'May',
            value: 0
          },
          {
            month: 'June',
            value: 0
          },
          {
            month: 'July',
            value: 0
          },
          {
            month: 'August',
            value: 0
          },
          {
            month: 'September',
            value: 0
          },
          {
            month: 'October',
            value: 0
          },
          {
            month: 'November',
            value: 0
          },
          {
            month: 'December',
            value: 0
          },
          {
            month: 'Total',
            value: 0
          }
        ],
        sum_amount: 0,
        approval_status: 0,
        year: new Date(),
        departement_id: 0,
        division_id: 0,
        code: ''
      },
      taxonomies: [],
      amountHeaders: [
        { text: 'Q1' },
        { text: 'Q2' },
        { text: 'Q3' },
        { text: 'Q4' },
        { text: 'PO' },
        { text: 'Non-PO' },
        { text: 'Remaining IO' },
        { text: 'GR' },
        { text: 'Actual Non-PO' },
        { text: 'Remaining PO' },
        { text: 'Remaining Non-PO' },
        { text: 'Status' }
      ],
      isBrandNull: false,
      investment_types: []
    };
  },
  mounted() {
    if (this.isLoggedInAsSales) {
      this.headers.splice(5, 0, { text: 'Channel' });
      this.headers.splice(6, 0, { text: 'Account' });
      let indexEnd = this.headers.findIndex(val => val.text == 'End');
      this.headers.splice(indexEnd + 1, 0, { text: 'Investment Type' });
      this.getInvestmentType();
    }
    document.addEventListener('wheel', function() {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    });
    this.item.pic = localStorage.getItem('name');
    this.today = moment(this.today).format('DD MMM YYYY');
    this.isAdhoc = JSON.parse(localStorage.getItem('isAdhoc'));
    if (this.id) {
      this.breadcrumbs[1].text = 'SPENDING REPORT / MASS REVISION';
      this.btnNextDisabled = false;
    } else {
      if (this.isAdhoc) {
        this.breadcrumbs[1].text = 'SPENDING REPORT / ADD NEW AD HOC IO';
        this.btnNextDisabled = false;
      } else {
        this.breadcrumbs[1].text = 'SPENDING REPORT / ADD NEW IO';
      }
    }
    setTimeout(() => {
      this.progressDialogLoading = false;
    }, 300);
    this.getGuideline();
    if (this.id) {
      this.headers = this.headers.filter(item => {
        return item.text !== 'Stage';
      });
    }
  },
  watch: {
    brand(val) {
      this.item.brand_name = val.name;
      this.item.brand_id = val.id;
      this.item.house_name = val.house.name;
      this.item.house_id = val.house.id;
      this.item.entity_name = val.entity.name;
      this.item.entity_id = val.entity.id;
      this.getProduct();
    },
    'item.product'(val) {
      this.item.stage = val.stage.name;
    },
    'item.taxonomy'(val) {
      this.item.cc = val.costCenter.code;
      this.item.cc_desc = val.costCenter.desc;
      this.item.ce = val.costElement.code;
      this.item.ce_desc = val.costElement.desc;
      this.item.costElement =
        val.costElement.code + ' - ' + val.costElement.desc;
      this.item.material = val.mat_group;
      this.item.nature_activity = val.costCenter.costNature.nature_activity;
      this.item.taxonomy_category = val.costCenter.costNature.category;
      this.item.bpc_line = val.bpc;
      this.item.pillars = val.costCenter.type;
    },
    'item.start'(val) {
      this.item.amount = [
        {
          month: 'January',
          value: 0
        },
        {
          month: 'February',
          value: 0
        },
        {
          month: 'March',
          value: 0
        },
        {
          month: 'April',
          value: 0
        },
        {
          month: 'May',
          value: 0
        },
        {
          month: 'June',
          value: 0
        },
        {
          month: 'July',
          value: 0
        },
        {
          month: 'August',
          value: 0
        },
        {
          month: 'September',
          value: 0
        },
        {
          month: 'October',
          value: 0
        },
        {
          month: 'November',
          value: 0
        },
        {
          month: 'December',
          value: 0
        },
        {
          month: 'Total',
          value: 0
        }
      ];
      this.dateCheck(val, this.item.end);
    },
    'item.end'(val) {
      this.dateCheck(this.item.start, val);
    },
    'item.year'() {
      this.item.start = '';
      this.item.end = '';
    }
  },
  computed: {
    minDate() {
      let startYear = moment(this.item.year).format('YYYY');
      return startYear + '-01-01';
    },
    maxDate() {
      let endYear = moment(this.item.year).format('YYYY');
      return endYear + '-12-31';
    },
    validationAccount() {
      if (this.isLoggedInAsSales && this.item.account.length > 0) {
        return true;
      } else if (this.isLoggedInAsSales && this.item.account.length === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getInvestmentType() {
      this.$store
        .dispatch('investmentType/getAll', { paginate: false })
        .then(data => {
          if (data.code === 200) {
            this.investment_types = data.data;
          }
        });
    },
    saveChannel(item) {
      this.item.account = item.account;
      this.item.channel = item.channel;
    },
    monthCheck(val) {
      let isMonth = this.activeMonth.includes(val);
      return !isMonth;
    },
    dateCheck(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      let today = new Date();
      today.setHours(0, 0, 0);
      if (startDate > endDate) {
        this.validationMessage = 'Start Date must be earlier than End Date.';
        this.isDisabledAdd = true;
      } else {
        this.validationMessage = '';
        this.isDisabledAdd = false;
      }
      let setEndDate = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        this.daysInMonth(endDate.getMonth() + 1, endDate.getFullYear())
      );
      if (end.slice(5, 7) === '02') {
        /*kalau end month februari malah jadi ke set nya sampai maret jadi di set paksa ke februari */
        setEndDate = new Date(
          setEndDate.setMonth(1)
        ); /*set month dimulai dari 0 */
      }
      this.activeMonth = [];
      let tempStart = moment(startDate);
      let tempEnd = moment(setEndDate);
      while (tempStart.isSameOrBefore(tempEnd)) {
        this.activeMonth.push(tempStart.format('MMMM'));
        tempStart.add(1, 'month');
      }
    },
    afterComplete(file) {
      var fileType = file.upload.filename.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        if (file.size <= 5000000) {
          this.xlxFile = file;
          this.nameFile = file.upload.filename;
          this.isDisabled = false;
        } else {
          Swal.fire('Failed!', 'File size can not more than 5 mb', 'error');
          this.$refs.myVueDropzone.removeAllFiles();
        }
      } else {
        Swal.fire(
          'Failed!',
          'Only file types document .xlsx and .xls are allowed.',
          'error'
        );
        this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    afterRemoved() {
      this.items = [];
    },
    fileRemoved(index, name) {
      var indexFile = this.support_docs[index].name.indexOf(name);
      this.support_docs[index].docs.splice(indexFile, 1);
      this.support_docs[index].name.splice(indexFile, 1);
      this.support_docs[index].file.splice(indexFile, 1);
      const item = this.items[index];
      if (this.support_docs[index].docs.length === 0) {
        item.btnDisabled = true;
        item.isUploaded = false;
        this.btnNextDisabled = true;
        this.$set(this.items, index, item);
      }
      // switch (name) {
      //   case 'AP':
      //     this.$refs.myVueDropzone1.removeAllFiles();
      //     break;
      //   case 'Cost Estimate':
      //     this.$refs.myVueDropzone2.removeAllFiles();
      //     break;
      // }
    },
    onComplete(file, index, name) {
      var fileType = file.upload.filename.split('.').pop();
      var fileTypes = [
        'xlsx',
        'xls',
        'XLS',
        'XLSX',
        'doc',
        'DOC',
        'docx',
        'DOCX',
        'pdf',
        'PDF',
        'ppt',
        'PPT',
        'pptx',
        'PPTX'
      ];
      if (fileTypes.includes(fileType)) {
        if (file.size <= 15000000) {
          this.support_docs[index].docs.push(file);
          this.support_docs[index].name.push(name);
          this.support_docs[index].file.push(file.upload.filename);

          const item = this.items[index];
          if (this.support_docs[index].docs.length > 0) {
            // this.items[index].btnDisabled = false;
            item.btnDisabled = false;
            this.$set(this.items, index, item);
          }
          this.dialog1 = false;
        } else {
          Swal.fire('Failed!', 'File size can not more than 15 mb', 'error');
        }
      } else {
        Swal.fire(
          'Failed!',
          'Only file types document .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf are allowed.',
          'error'
        );
      }
    },
    getGuideline() {
      this.$store.dispatch('spending/getGuideline').then(data => {
        if (data.code === 200) {
          this.guidelines = data.data.result;
        }
      });
    },
    parseFile() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.isSave = false;
      let formData = new FormData();
      if (this.id) {
        // for revise
        formData.append('revise', this.xlxFile);
        let param = {
          profileId: localStorage.getItem('profile_id'),
          budgetCode: this.id
        };
        let endpointRevise = this.isLoggedInAsSales
          ? 'spending/parseReviseSales'
          : 'spending/parseRevise';
        this.$store
          .dispatch(endpointRevise, {
            payload: formData,
            params: param
          })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.items = data.data.result;
              this.isStatus = data.data.status;
              this.isDisabled = true;
              for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                item.isUploaded = false;
                item.btnDisabled = true;
                this.$set(this.items, i, item);
                this.support_docs.push({
                  code: this.items[i].code,
                  name: [],
                  file: [],
                  docs: []
                });
              }
              if (this.isLoggedInAsSales) {
                this.items = this.items.map(item => {
                  return {
                    ...item,
                    account: item.account_ids.map((val, index) => {
                      return {
                        id: val,
                        name: item.account[index]
                      };
                    }),
                    channel: item.channel.map((val, index) => {
                      return {
                        id: index,
                        name: val
                      };
                    })
                  };
                });
              }
            } else {
              if (data) {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            if (err.response) {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        formData.append('spending', this.xlxFile);
        let endpoint = this.isLoggedInAsSales
          ? 'spending/parseSales'
          : 'spending/parse';
        this.$store
          .dispatch(endpoint, formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.items = data.data.result;
              this.isStatus = data.data.status;
              this.isDisabled = true;
              if (this.isLoggedInAsSales) {
                this.items = this.items.map(item => {
                  return {
                    ...item,
                    account: item.accounts,
                    channel: item.channels.map((val, index) => {
                      return {
                        id: index,
                        name: val
                      };
                    })
                  };
                });
              }
              for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                item.isUploaded = false;
                item.btnDisabled = true;
                this.$set(this.items, i, item);
                this.support_docs.push({
                  code: this.items[i].code,
                  name: [],
                  file: [],
                  docs: []
                });
              }
            } else {
              if (data) {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            if (err.response) {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    prevStep(n) {
      this.e1 = n - 1;
    },
    changeManual() {
      this.uploadIo = true;
    },
    async changeUpload() {
      this.uploadIo = false;
      if (this.item.budget_owner === '') {
        await this.getDetailProfile();
      }
      if (this.product_hierarchies.length === 0) {
        await this.getProduct();
      }
      if (this.taxonomies.length === 0) {
        await this.getTaxonomy();
      }
    },
    getDetailProfile() {
      this.progressDialogLoading = true;
      let id = localStorage.getItem('profile_id');
      return this.$store
        .dispatch('spending/detailProfile', { id })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.item.budget_owner = data.data.desc;
            this.item.budget_owner_id = data.data.id;
            this.item.house_name = data.data.house;
            this.item.house_id = data.data.house_id;
            this.item.entity_name = data.data.entity;
            this.item.entity_id = data.data.entity_id;
            this.item.brand_name = data.data.brand;
            this.item.brand_id = data.data.brand_id;
            this.item.departement_id = data.data.dept_id;
            this.item.department_name = data.data.dept;
            this.item.division_id = data.data.divisi_id;
            this.item.hn_category = data.data.category;
            this.isBrandNull = this.item.brand_id ? false : true;
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        });
    },
    getProduct() {
      if (this.item.brand_id) {
        this.progressDialogLoading = true;
        let params = {
          brand_id: this.item.brand_id
        };
        return this.$store
          .dispatch('spending/getProduct', params)
          .then(data => {
            if (data.code === 200) {
              this.progressDialogLoading = false;
              this.product_hierarchies = data.data;
            } else {
              this.progressDialogLoading = false;
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
          });
      } else {
        this.getBrand();
      }
    },
    getBrand() {
      this.$store
        .dispatch('budget/getBrand', { paginate: false })
        .then(data => {
          if (data.code === 200) {
            this.brands = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getTaxonomy() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('taxonomy/getAll', {
          paginate: false
        })
        .then(data => {
          if (data.code === 200) {
            this.progressDialogLoading = false;
            this.taxonomies = data.data.filter(item => item.costCenter);
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    async addData() {
      if (this.item.year) {
        if (this.validationAccount) {
          const validated = await this.$refs.obs.validate();
          if (validated) {
            if (this.item.amount[12].value > 0) {
              Swal.fire({
                title: '',
                text: 'Are you sure want to add this spending data?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a0f6',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, save it!',
                cancelButtonText: 'Cancel'
              }).then(result => {
                if (result.value) {
                  this.progressDialogLoading = true;
                  let year = moment(this.item.year).format('YYYY');
                  let params = {
                    year: year,
                    adhoc: this.isAdhoc,
                    budget_owner_id: this.item.budget_owner_id,
                    budget_owner_name: this.item.budget_owner,
                    brand_id: this.item.brand_id
                  };
                  return this.$store
                    .dispatch('spending/addIO', params)
                    .then(data => {
                      if (data.code === 200) {
                        this.progressDialogLoading = false;
                        this.item.budget_code = data.data.budget_code;
                        this.item.code = data.data.io_code;

                        let item = {
                          ...this.item,
                          product: this.item.product.material_desc,
                          stage: this.item.stage,
                          amount: this.item.amount,
                          sum_amount: this.item.amount[12],
                          year: year,
                          product_id: this.item.product.id,
                          taxonomy_code: this.item.taxonomy.code
                        };
                        delete item.costElement;
                        delete item.taxonomy;
                        this.items.push(item);
                        this.isStatus = data.data.status;
                        this.isDisabled = true;
                        this.support_docs = [];
                        for (let i = 0; i < this.items.length; i++) {
                          const itemData = this.items[i];
                          itemData.isUploaded = false;
                          itemData.btnDisabled = true;
                          this.$set(this.items, i, itemData);
                          this.support_docs.push({
                            code: this.items[i].code,
                            name: [],
                            file: [],
                            docs: []
                          });
                        }
                        Swal.fire('Success!', data.message.text_en, 'success');
                        this.clearForm();
                        this.getDetailProfile();
                      } else {
                        this.progressDialogLoading = false;
                        Swal.fire(
                          'Failed!',
                          data.response.data.message.text_en,
                          'error'
                        );
                      }
                    })
                    .catch(err => {
                      this.progressDialogLoading = false;
                      Swal.fire(
                        'Failed!',
                        err.response.data.message.text_en,
                        'error'
                      );
                    });
                }
              });
            } else {
              Swal.fire(
                'Failed!',
                'Total amount must be greater than 0',
                'error'
              );
            }
          } else {
            Swal.fire('Failed!', 'Please fill for all required field', 'error');
          }
        } else {
          Swal.fire('Failed!', 'The Account field is required', 'error');
        }
      } else {
        Swal.fire('Failed!', 'The Year field is required', 'error');
      }
    },
    clearForm() {
      this.brand = {};
      this.brans = [];
      this.item = {
        entity_name: this.item.entity_name,
        entity_id: this.item.entity_id,
        brand_name: this.item.brand_name,
        brand_id: this.item.brand_id,
        house_name: this.item.house_name,
        house_id: this.item.house_id,
        product: null,
        stage: '',
        cc_desc: '',
        cc: '',
        costElement: '',
        material: '',
        nature_activity: '',
        taxonomy_category: '',
        budget_owner: this.item.budget_owner,
        budget_owner_id: this.item.budget_owner_id,
        pic: this.item.pic,
        taxonomy: null,
        taxonomy_code: '',
        budget_code: '',
        pillars: '',
        method: '',
        campaign: '',
        bpc_line: '',
        start: '',
        end: '',
        activity_desc: '',
        channel: [],
        account: [],
        amount: [
          {
            month: 'January',
            value: 0
          },
          {
            month: 'February',
            value: 0
          },
          {
            month: 'March',
            value: 0
          },
          {
            month: 'April',
            value: 0
          },
          {
            month: 'May',
            value: 0
          },
          {
            month: 'June',
            value: 0
          },
          {
            month: 'July',
            value: 0
          },
          {
            month: 'August',
            value: 0
          },
          {
            month: 'September',
            value: 0
          },
          {
            month: 'October',
            value: 0
          },
          {
            month: 'November',
            value: 0
          },
          {
            month: 'December',
            value: 0
          },
          {
            month: 'Total',
            value: 0
          }
        ],
        sum_amount: 0,
        approval_status: 0,
        year: '',
        departement_id: 0,
        division_id: 0,
        code: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    showDetail(item) {
      if (this.e1 === 2) {
        this.progressDialogLoading = true;
        this.loading = true;
        setTimeout(() => {
          this.progressDialogLoading = false;
          this.loading = false;

          this.code = item.code;
          this.ce_desc = item.ce_desc;
          this.ce_code = item.ce;
          this.detailIO = true;
        }, 300);
      }
    },
    uploadFile(index) {
      this.progressDialogLoading = true;
      this.loading = true;

      let body = {
        io_code: this.code
      };
      const payload = new FormData();
      Object.keys(body).forEach(key => {
        payload.append(key, body[key]);
      });
      Array.from(this.support_docs[index].docs).forEach(file => {
        payload.append('docs[]', file);
      });
      this.$store
        .dispatch('spending/uploadDocs', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.btnNextDisabled = false;
            const item = this.items[index];
            // this.support_docs.map((value, index) => {
            //   value.file.map(val, index =>{
            //     val = data.data[index].nameFile;
            //   })
            // });
            let nameFile = data.data.map(val => {
              return val.nameFile;
            });
            for (let i = 0; i < this.support_docs.length; i++) {
              if (this.support_docs[i].code === data.data[0].ioCode) {
                this.support_docs[i].file = nameFile;
              }
            }
            // this.support_docs = [...this.support_docs].map(item => ({
            //   ...item,
            //   file: data.data.map(item => item.nameFile)
            // }));
            item.isUploaded = true;
            item.btnDisabled = true;
            this.$set(this.items, index, item);
            Swal.fire('Success!', data.message.text_en, 'success');
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    confirmStatusRevise() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to save this revise data?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a0f6',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'Cancel'
      }).then(result => {
        if (result.value) {
          this.submit(this.statusIO);
        }
      });
    },
    confirmStatus() {
      if (this.isAdhoc) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this spending Ad hoc data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#28a0f6',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, save it!',
          cancelButtonText: 'Cancel'
        }).then(result => {
          if (result.value) {
            this.statusIO = 'create';
            this.submit(this.statusIO);
          }
        });
      } else if (this.isStatus == 'replace') {
        Swal.fire({
          title: '',
          text: 'Do you want to add new IO or replace existing IO data?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#28a0f6',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Add new IO',
          cancelButtonText: 'Replace existing IO'
        }).then(result => {
          if (result.value) {
            this.statusIO = 'create';
            this.submit(this.statusIO);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.confirmReplace();
          }
        });
      } else {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this spending data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#28a0f6',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, save it!',
          cancelButtonText: 'Cancel'
        }).then(result => {
          if (result.value) {
            this.statusIO = 'create';
            this.submit(this.statusIO);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire('Cancelled', 'Save IO data cancelled', 'error');
          }
        });
      }
    },
    confirmReplace() {
      Swal.fire({
        title: 'Are you sure want to replace the IO data?',
        text: 'If you replace, your existing IO data will be lost!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, replace it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.statusIO = 'replace';
          this.submit(this.statusIO);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Replace IO data cancelled', 'error');
        }
      });
    },
    getTemplate() {
      let profile_id = localStorage.getItem('profile_id');
      let division = JSON.parse(localStorage.userProfile);
      window.open(
        this.baseUrl +
          '/v1/io/template?profileId=' +
          profile_id +
          '&division=' +
          division.mapping.divisi.alias +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    submit(status) {
      this.progressDialogLoading = true;
      this.loading = true;
      let dataArray = [];
      this.support_docs.map((value, index) => {
        let docs = [];
        value.file.map((detail, indexDocs) => {
          docs[indexDocs] = {
            io_code: value.code,
            name: value.name[indexDocs],
            file: detail
          };
        });
        dataArray[index] = {
          docs: docs
        };
      });
      var formatted = this.items.map((item, index) => {
        item.method = item.method.toLowerCase();
        item.account = item.account ? item.account.map(val => val.id) : [];
        item.support_docs = dataArray[index].docs;
        return item;
      });
      let body = {};
      if (this.id) {
        /*save revise*/
        body = {
          status: this.isStatus,
          spending: formatted
        };
        this.$store
          .dispatch('spending/createRevise', body)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              localStorage.setItem('spendingYear', formatted[0].year);
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'spending'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        /*save spending*/
        let bodyData = {
          status,
          spending: formatted,
          adhoc: this.isAdhoc
        };
        this.$store
          .dispatch('spending/create', bodyData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              localStorage.setItem('spendingYear', formatted[0].year);
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'spending'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    calculateTotal() {
      this.item.amount[12].value = 0;
      const total = this.item.amount
        .filter(item => item.month !== 'Total')
        .reduce((prevValue, item) => {
          prevValue = +prevValue + +item.value;
          return prevValue;
        }, 0);
      this.item.amount[12].value = total;
    }
  }
};
</script>
<style>
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.yearIO .mx-input {
  height: 40px !important;
}
.v-select:not(.v-select--is-multi).v-text-field--single-line
  .v-select__selections,
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  font-size: 14px !important;
}
tr:hover {
  background-color: #f5f5f5 !important;
}
.drawer-menu--scroll-dialog {
  max-height: 500px;
  overflow: auto;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}
</style>
